import { render, staticRenderFns } from "./CompactWarrantyOption.vue?vue&type=template&id=05844f45"
import script from "./CompactWarrantyOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompactWarrantyOption.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompactWarrantyOption.vue?vue&type=style&index=0&id=05844f45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports